import styled, { css } from 'styled-components'

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px 0 26px 0;

    @media (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      padding: 14px 16px 16px 16px;
    }
  `}
`

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const IconText = styled.div<{ $alignTop?: boolean }>`
  ${({ $alignTop = false }) => css`
    align-items: ${$alignTop ? 'flex-start' : 'center'};
    display: flex;
    gap: 8px;
    padding: 8px 0;
  `}
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Item = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    border-bottom: 1px dashed ${theme.colors.getColor('neutral-light')};
  `}
`

export const Columns = styled.div<{ $spaceBetween?: boolean }>`
  ${({ $spaceBetween = false }) => css`
    display: flex;
    gap: 20px;
    justify-content: ${$spaceBetween ? 'space-between' : 'initial'};
    padding: 4px 0 8px;
  `}
`

export const ColumnItem = styled.div``
